<template>
  <div style="display:inline-flex;align-items:center;margin-bottom:0;">
    <el-date-picker
      v-model="StartEndDate"
      type="daterange"
      size="small"
      value-format="yyyy-MM-dd HH:mm:ss"
      format="yyyy-MM-dd HH:mm:ss"
      :range-separator="$t('StartEndDate.to')"
      :start-placeholder="$t('StartEndDate.startDate')"
      :end-placeholder="$t('StartEndDate.endDate')"
      @input="putStartEndDate"
      style="width:300px;"
    ></el-date-picker>
  </div>
</template>

<script>
import { hasPermission } from '@/permission/index.js'
export default {
  name: 'StartEndDate',
  props: {
    label: {  // 标题
      type: String,
      default: ''
    },
    icon: {  // 显示图标
      type: String,
      default: ''
    },
    size: {  // 尺寸
      type: String,
      default: 'mini'
    },
    type: {  // 类型
      type: String,
      default: null
    },
    loading: {  // 加载标识
      type: Boolean,
      default: false
    },
    disabled: {  // 是否禁用
      type: Boolean,
      default: false
    },
    perms: {  // 权限标识，外部使用者传入
      type: String,
      default: null
    }
  },
  data() {
    return {
      StartDate: '',
      EndDate: '',
      StartEndDate: [new Date(new Date().setHours(0, 0, 0, 0) - 3600 * 1000 * 24 * 7), new Date(new Date().setHours(23, 59, 59, 999))]
    }
  },
  methods: {
    putStartEndDate: function (val){
      if (val && val.length === 2) {
        // 获取开始时间
        const startDate = new Date(val[0] < val[1] ? val[0] : val[1]);
        // 获取结束时间并设置为当天的23:59:59
        const endDate = new Date(val[0] < val[1] ? val[1] : val[0]);
        //endDate.setHours(23, 59, 59, 999);
        
        this.startDate = startDate;
        this.endDate = endDate;

        const formattedStartDate = `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${String(startDate.getDate()).padStart(2, '0')} 00:00:00`;
        // 格式化结束时间为 yyyy-MM-dd HH:mm:ss
        const formattedEndDate = `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${String(endDate.getDate()).padStart(2, '0')} 23:59:59`;
      
        // 更新v-model绑定的值，确保页面显示的内容包含23:59:59
        this.StartEndDate = [formattedStartDate, formattedEndDate];

        this.$emit('search-date-event', formattedStartDate, formattedEndDate);
      }
    },
    hasPerms: function (perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms) & !this.disabled
    }
  },
  mounted() {

    // 2015-02-25 修复默认值没有返回父组件，导致查不到数据
    this.putStartEndDate(this.StartEndDate);
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Core/StartEndDate.vue